import { render, staticRenderFns } from "./CreateBlog.vue?vue&type=template&id=78d36c98&scoped=true"
import script from "./CreateBlog.vue?vue&type=script&lang=js"
export * from "./CreateBlog.vue?vue&type=script&lang=js"
import style0 from "./CreateBlog.vue?vue&type=style&index=0&id=78d36c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d36c98",
  null
  
)

export default component.exports